import { useMutation } from '@tanstack/react-query'
import { syncMeetingActions } from '../api/meetingApi'
import type { ActionInput } from '../../actions/types'

/**
 * Aksiyon senkron mutasyonu (044) — detay ekranında aksiyonlar hep düzenlenebilir; her ekle/düzenle/sil
 * anında bu uçla kaydedilir (Temel Bilgiler'den bağımsız). Başarıda güncel aksiyon listesi döner; çağıran
 * satırları tazeler. Detay sorgusu invalidate edilmez (editör durumunu dönen listeden yönetir; detay mount'ta
 * zaten tazelenir) — hızlı düzenlemede refetch churn'ü olmaz.
 */
export function useSyncMeetingActions(meetingId: number) {
  return useMutation({
    mutationFn: (actions: ActionInput[]) => syncMeetingActions(meetingId, actions),
  })
}
